export const ACCESS_TOKEN = "access-token";
export const REQUEST_HEADER_AUTH_KEY = "Authorization";
export const TOKEN_TYPE = "Bearer ";
export const USER_ROLE = "user-role";
export const SHOW_TOAST_MESSAGE = "SHOW_TOAST_MESSAGE";
export const REMEMBER_ME_KEY = "rememberMe";
export const REMEMBERED_EMAIL_KEY = "rememberedEmail";
export const USER_NAME = "userName";
export const USER_EMAIL = "userEmail";
export const USER_ID = "userId";
